export enum CF_USECASE {
  SERVER = 'server',
  MONITORING = 'monitoring',
  MANAGEMENT = 'management',
}
